import React, {useContext} from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';
import {toDate} from './index';
import {LocaleContext} from '@src/contexts/LocaleContext';

export function OrderTaskCreated(props: TypicalMessageProps) {
    useContext(LocaleContext);

    const details = props.model.message_details;
    if (details['@type'] !== 'order-task.change-status.created' || !('type' in details)) {
        return <TypicalMessage model={props.model} options={props.options}/>;
    }


    return <TypicalMessage
            model={props.model}
            options={props.options}
            messageKeysWithStatusId={['payload.status_id']}
            replace={{
                will_change_at: toDate(details.payload.will_change_at),
                order_task_id: details.order_task_id,
            }}
            choice={details.payload.target === 'order' ? 1 : 2}
            optionsKey={details.payload.target === 'order' ? 'status' : 'productStatuses'}
    />;
}
